/**
 * 设备数据接口
 */

import instance from '@/utils/axios';

/**
 * 获取设备在线状态
 * @param {*} data
 * @returns
 */
export function deviceStatueServer(data) {
  return instance.post('/remote/status', data);
}

/**
 * 获取设备列表
 * @param {{sn: String, order: String, offset: Number, limit: Number, deviceTypeCode: String}} data
 */
export function getDeviceList(data) {
  return instance.post('/remote/list', data);
}

/**
 * 控制设备 开始检测
 * @param {{sn: String, order: String, offset: Number, limit: Number, deviceTypeCode: String}} data
 * @returns {Promise}
 */
export function start(data) {
  return instance.post('/remote/start', data);
}

/**
 * 控制设备 检测结束
 * @param {{sn: String, testId: String, status: Number, message: String, materialMap: Array<String>}} data
 * @returns {Promise}
 */
export function finish(data) {
  return instance.post('/remote/finish', data);
}

/**
 * 控制设备 状态恢复正常
 * @param {{sn: String}} data
 */
export function recovery(data) {
  return instance.post('/remote/recover', data);
}

/**
 * 获取设备详情列表
 * @param {{deviceTypeCode: Array<String>, isConnect: String, limit: Number, mode: String, offset: Number, sn: Array<Number>}} data
 * @returns {Promise<any>}
 */
export function get(data) {
  return instance.post('/remote/get', data);
}

/**
 * 关闭设备连接
 * @returns {Promise<any>}
 */
export function close() {
  return instance.get('/remote/close');
}

/**
 * 停止检测
 * @param {*} data
 * @returns
 */
export function stopDetection(data) {
  return instance.post('/remote/stop', data);
}

/**
 * FCBR、BM3001 远程控制
 * @param {*} data
 * @returns
 */
export function fcbrStartServer(data) {
  return instance.post('/remote/fcbrstart', data);
}
